// extracted by mini-css-extract-plugin
export var phone = "_1z-0";
export var phoneDragging = "_1z-1";